import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { OrganizationRole } from "../../common/models/organization-role";
import { User } from "../../common/models/user";
import { Organization } from "../../common/models/organization";

export class OrganizationRights {
    public get SEE() {
        return this._see;
    }
    public get EDIT() {
        return this._edit;
    }
    public get DELETE() {
        return this._delete;
    }
    public get UPDATE_USER_ROLES() {
        return this._updateUserRoles;
    }
    /**
     * YM : Ce gestionnaire fait le job demandé en l'état.
     * Je le laisse tel quel. On l'adaptera en fonction des besoins futurs (si
     * nécessaire).
     */

    private utilsProvider: UtilsProvider;
    private params: OrganizationRightsParams | null = null;

    private _see = false;

    private _edit = false;

    private _delete = false;

    private _updateUserRoles = false;
    constructor(utils: UtilsProvider) {
        this.utilsProvider = utils;
    }

    public evaluate(params: OrganizationRightsParams): void {
        this.params = params;

        this._see = this.utilsProvider.hasOneOfs(params.rolesIds, [
            OrganizationRole.ID_ADMIN,
            OrganizationRole.ID_SUPERCOACH,
            OrganizationRole.ID_COACH,
            OrganizationRole.ID_ATHLETE,
            OrganizationRole.ID_GUEST,
        ]);
        this._edit = this.utilsProvider.hasOneOfs(params.rolesIds, [
            OrganizationRole.ID_ADMIN,
            // OrganizationRole.ID_SUPERCOACH,
            // OrganizationRole.ID_COACH,
        ]);
        this._delete = this.utilsProvider.hasOneOfs(params.rolesIds, [
            OrganizationRole.ID_ADMIN,
            // OrganizationRole.ID_SUPERCOACH,
            // OrganizationRole.ID_COACH,
        ]);
        this._updateUserRoles = this.utilsProvider.hasOneOfs(params.rolesIds, [
            OrganizationRole.ID_ADMIN,
        ]);
    }
}

export interface OrganizationRightsParams {
    user: User;
    organization: Organization;
    rolesIds: number[];
}
